import { render, staticRenderFns } from "./cabinetmng.vue?vue&type=template&id=6dd5e38f&scoped=true"
import script from "./cabinetmng.vue?vue&type=script&lang=js"
export * from "./cabinetmng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5e38f",
  null
  
)

export default component.exports